/**
 * BAJO QUE PESTAÑA SE AGRUPA UN TIPO DE POLIZA.
 *
 * La pestaña Documentos de la ficha tiene una sub-pestaña por tipo de poliza, y
 * un tipo PROPIO de la agencia que se llama igual que uno de fabrica tiene que
 * contar en la MISMA, o el agente ve dos "Salud" con sus documentos repartidos
 * entre las dos (Maricarmen, 2026-07-27). Lo mismo con los sinonimos de Salud
 * (2026-07-28).
 *
 * Solo para MOSTRAR y CONTAR: lo guardado no se reescribe nunca aqui, asi que
 * ningun documento se mueve ni se esconde por pasar por estas funciones.
 *
 * Vivia dentro de DocFolder.jsx. Esta fuera para poder ejecutarlo en una prueba
 * sin arrastrar React, y porque la regla es una sola: el dia que se corrija, se
 * corrige en un sitio.
 */
import { POLICY_TYPES } from './policyTypes.js';

/** Un tipo creado por la agencia viaja con el prefijo "custom:". */
export function esTipoPropio(id) {
  return typeof id === 'string' && id.startsWith('custom:');
}

/**
 * El nombre visible de un tipo. SIN el respaldo a "aca" de getPolicyType: un id
 * desconocido se devuelve a si mismo, para que un id viejo o sin hidratar no
 * acabe arrastrado en silencio a la pestaña de Salud.
 */
export function etiquetaDelTipo(id, es = true) {
  if (esTipoPropio(id)) return id.slice(7);
  const pt = POLICY_TYPES.find((p) => p.id === id);
  if (!pt) return id;
  return es ? (pt.labelEs || pt.label) : pt.label;
}

/** Nombre de fabrica (en minusculas) -> su id. Gana el primero. */
export function idesDeFabricaPorNombre(es) {
  const mapa = {};
  POLICY_TYPES.forEach((pt) => {
    if (!pt || !pt.id || pt.custom) return;
    const k = String((es ? (pt.labelEs || pt.label) : pt.label) || '').trim().toLowerCase();
    if (k && !(k in mapa)) mapa[k] = pt.id;
  });
  // Sinonimos de Salud (Lissette 2026-07-28): algunas agencias se crearon un
  // tipo propio llamado "Health"/"Salud"/"Marketplace" para lo mismo que ya era
  // el ramo de fabrica. Se busca por ID y no por etiqueta porque el ramo se
  // renombro a "Salud" el 2026-08-18: buscarlo por su nombre viejo dejaba esto
  // apagado en silencio. El id no cambia nunca.
  const aca = (POLICY_TYPES.find((p) => p && p.id === 'aca' && !p.custom) || {}).id;
  if (aca) {
    ['health', 'salud', 'marketplace', 'mercado', 'obamacare', 'aca', 'aca marketplace', 'aca/marketplace']
      .forEach((k) => { if (!(k in mapa)) mapa[k] = aca; });
  }
  return mapa;
}

/**
 * El id con el que hay que AGRUPAR este tipo. Un id de fabrica se queda como
 * esta; un tipo propio que se llame igual que uno de fabrica se pliega sobre
 * el. Lo demas se devuelve intacto.
 *
 * Solo para mostrar y contar: lo guardado no se reescribe nunca aqui, asi que
 * ningun documento se mueve ni se esconde por pasar por esta funcion.
 */
export function tipoCanonico(id, es = true) {
  if (!id) return id;
  if (POLICY_TYPES.find((p) => p.id === id && !p.custom)) return id;
  const mapa = idesDeFabricaPorNombre(es);
  return mapa[String(etiquetaDelTipo(id, es) || '').trim().toLowerCase()] || id;
}
